import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AddTablePresetActionPayload,
  DeleteTablePresetActionPayload,
  SetTableKeysActionPayload,
} from '../../../models/actions/tables.action.models';

const FEATURE_KEY = 'tables';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface TablesState {
  tables: {
    [key: string]: {
      currentTableKeys: string[];
      presets: {
        id: string;
        name: string;
        keys: string[];
      }[];
    };
  };
  pageSize: number;
}

const initialState: TablesState = {
  tables: {},
  pageSize: 10,
};

export const tablesSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setTableKeys: (state, action: PayloadAction<SetTableKeysActionPayload>) => {
      const table = state.tables[action.payload.tableName];
      if (table) {
        state.tables[action.payload.tableName].currentTableKeys =
          action.payload.keys;
      } else {
        state.tables[action.payload.tableName] = {
          currentTableKeys: action.payload.keys,
          presets: [],
        };
      }
    },
    addPreset: (state, action: PayloadAction<AddTablePresetActionPayload>) => {
      const table = state.tables[action.payload.tableName];
      if (table) {
        state.tables[action.payload.tableName].presets.push({
          id: generateUUID(),
          name: action.payload.name,
          keys: action.payload.keys,
        });
      }
    },
    deletePreset: (
      state,
      action: PayloadAction<DeleteTablePresetActionPayload>
    ) => {
      const table = state.tables[action.payload.tableName];
      if (table) {
        state.tables[action.payload.tableName].presets = state.tables[
          action.payload.tableName
        ].presets.filter((preset) => preset.id !== action.payload.id);
      }
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
  },
  //extraReducers: (builder) => {},
});

/*
 * Export reducer for store configuration.
 */
export const tablesReducer = tablesSlice.reducer;
export const tablesActions = tablesSlice.actions;

const state = (rootState: any): TablesState => rootState[FEATURE_KEY];

export const tablesSelector = createSelector(state, (state) => {
  return state.tables;
});

export const tablesPageSizeSelector = createSelector(state, (state) => {
  return state.pageSize;
});

/*
export const switchRequestsSelector = createSelector(state, (state) => {
  return state.switchRequests;
});
*/

const generateUUID = () => {
  let d = new Date().getTime(),
    d2 = (performance && performance.now && performance.now() * 1000) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16);
  });
};
